import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';

@Component({
  selector: 'webrendel-callback',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './callback.component.html'
})
export class CallbackComponent {
  error$: Observable<Error | null | undefined>;

  constructor(private authService: AuthService) {
    this.error$ = this.authService.error$;
  }
}
